import React from "react";
import { Card, Image, Tag, Row, Col, Button, Typography } from "antd";
import { FilePdfOutlined, EyeOutlined } from "@ant-design/icons";
import { MANUAL_KYC_MSG } from "../../../constants/constants";
import {
  getDocFileUrl,
  getDocReviewStatusTag,
  getManualKycDocTitle,
  isPdfFile,
} from "../../../helpers/manualKycReview";

const { Text } = Typography;

const PDF_PREVIEW_STYLE = {
  height: 120,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  background: "#fafafa",
  borderRadius: 4,
  border: "1px dashed #d9d9d9",
  padding: 8,
};

const ManualKycDocCards = ({ docList, isEntityOrHufOrNbfc, isHuf }) => {
  if (!docList || docList.length === 0) {
    return <Text type="secondary">{MANUAL_KYC_MSG.NO_DOCS}</Text>;
  }

  return (
    <Row gutter={[12, 12]}>
      {docList.map((doc, idx) => {
        const docTitle = getManualKycDocTitle(doc, { isEntityOrHufOrNbfc, isHuf });
        const docUrl = getDocFileUrl(doc);
        const statusTag = getDocReviewStatusTag(doc);
        const pdf = isPdfFile(docUrl);

        return (
          <Col span={8} key={`${doc.docMasterId || "doc"}-${idx}`}>
            <Card
              size="small"
              title={docTitle}
              extra={<Tag color={statusTag.color}>{statusTag.label}</Tag>}
            >
              {pdf ? (
                <div style={PDF_PREVIEW_STYLE}>
                  <FilePdfOutlined
                    style={{ fontSize: 32, color: "#ff4d4f", marginBottom: 6 }}
                  />
                  <Button
                    type="primary"
                    size="small"
                    icon={<EyeOutlined />}
                    onClick={() => window.open(docUrl, "_blank")}
                  >
                    {MANUAL_KYC_MSG.VIEW_PDF}
                  </Button>
                </div>
              ) : (
                <Image
                  src={docUrl}
                  alt={docTitle}
                  style={{ height: 120, objectFit: "contain", width: "100%" }}
                  fallback="https://via.placeholder.com/150?text=No+Preview"
                />
              )}
            </Card>
          </Col>
        );
      })}
    </Row>
  );
};

export default ManualKycDocCards;
